import React from 'react';

import { languages } from '../data';
import { useLanguage } from '../i18n';

const LanguageSwitch = () => {
  const { lang, setLang, t } = useLanguage();

  return (
    <div
      role='group'
      aria-label={t.languageLabel}
      className='flex shrink-0 items-center rounded-full bg-ink/[0.06] p-1 text-[13px] font-semibold'
    >
      {languages.map((code) => (
        <button
          key={code}
          type='button'
          lang={code}
          aria-pressed={lang === code}
          onClick={() => setLang(code)}
          className={`min-h-[36px] min-w-[44px] rounded-full px-3 uppercase transition-colors ${
            lang === code ? 'bg-ink text-canvas' : 'text-muted hover:text-ink'
          }`}
        >
          {code}
        </button>
      ))}
    </div>
  );
};

export default LanguageSwitch;
